import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { Setter, Store } from "../utils/storage";
import { getQuery } from "../utils/api";
import { getLocations } from "../utils/queries";

const storage = Store("session");

// Define Initial State
const State = {
  attractions: [],
  loadingAttractions: false,
};

// Define Actions
const Actions = (_set) => {
  const set = Setter(_set);

  // Fetch Attractions from API
  const fetchAttractions = async () => {
    set({ loadingAttractions: true });

    const URL = process.env.REACT_APP_API_ENDPOINT;

    const response = await getQuery(`${URL}/locations`);

    if (response.response === 200) {
      const allLocations = response.data.getLocations || [];
      const attractions = allLocations.filter((location) => location.type === "attraction");

      set({ attractions, loadingAttractions: false });
    } else {
      console.error("Error fetching attractions:", response.error || response);
      set({ attractions: [], loadingAttractions: false });
    }
  };

  return {
    fetchAttractions,
  };
};

// Create Store
const AttractionsStore = create(
  persist(
    (set, get) => {
      const actions = Actions(set, get);

      return {
        ...State,
        fetchAttractions: actions.fetchAttractions,
      };
    },
    {
      name: "app.attractions",
      storage: createJSONStorage(() => storage),
    }
  )
);

export default AttractionsStore;
